const errors = require('./errors')

module.exports = ({
  displayMessage = false,
  displayStackTrace = false,
  displayCustomAttributes = []
} = {}) => {
  const processError = (err) => {
    const data = {
      type: err.name,
      status: err.status || 500
    }
    if (err.fields) {
      data.fields = err.fields
    }
    if (err.errors) {
      data.errors = err.errors.map(error => processError(error))
    }
    if (displayMessage) {
      data.message = err.message
    }
    if (displayStackTrace && err.stack) {
      data.stack = err.stack.split('\n').map((stack) => {
        return stack.trim()
      })
      data.stack.shift()
    }

    displayCustomAttributes.forEach((customAttribute) => {
      if (err[customAttribute]) {
        data[customAttribute] = err[customAttribute]
      }
    })

    return data
  }

  const handlers = {
    notFoundHandler: (req, res, next) => {
      return next(new errors.NotFound(req.originalUrl))
    },

    defaultHandler: (err, req, res, next) => {
      if (res.headersSent) {
        next(err)
      } else {
        const data = processError(err)
        res.status(data.status)
        res.json(data)
      }
    }
  }
  return handlers
}
